import { __decorate } from "tslib";
import { LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { dividerStyles } from './styles';
let LitDivider = class LitDivider extends LitElement {
};
LitDivider.styles = dividerStyles;
LitDivider = __decorate([
    customElement("lit-divider")
], LitDivider);
export { LitDivider };
